var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"middleware-line",attrs:{"id":_vm.id,"data-current-middleware-id":_vm.currentItem,"data-next-middleware-id":_vm.nextItem}})}
var staticRenderFns = []

export { render, staticRenderFns }